var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.9326 21.9501C17.3506 21.9501 20.9326 18.5941 20.9326 14.4541C20.9326 10.7131 18.8976 7.78812 17.4946 6.39412C17.2346 6.13612 16.8006 6.25012 16.6546 6.58312C15.9066 8.27312 14.3506 10.7061 12.3616 10.7061C11.1296 10.8711 9.24962 9.81812 10.7676 4.59912C10.9046 4.12912 10.4026 3.75112 10.0186 4.06512C7.83762 5.85512 4.93262 9.46112 4.93262 14.4541C4.93262 18.5941 8.51462 21.9501 12.9326 21.9501Z",
    fill: "url(#paint0_linear_3443_13487)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40962 17.0091C6.22829 15.7614 7.34462 14.7371 8.65795 14.0285C9.97128 13.3199 11.4403 12.9493 12.9326 12.9501C14.4249 12.9493 15.894 13.3199 17.2073 14.0285C18.5206 14.7371 19.6369 15.7614 20.4556 17.0091C20.7713 16.1943 20.9331 15.328 20.9326 14.4541C20.9326 10.7131 18.8976 7.78812 17.4946 6.39412C17.2346 6.13612 16.8006 6.25012 16.6546 6.58312C15.9066 8.27312 14.3506 10.7061 12.3616 10.7061C11.1296 10.8711 9.24962 9.81812 10.7676 4.59912C10.9046 4.12912 10.4026 3.75112 10.0186 4.06512C7.83762 5.85512 4.93262 9.46112 4.93262 14.4541C4.93262 15.3511 5.10062 16.2111 5.40962 17.0091Z",
    fill: "url(#paint1_linear_3443_13487)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3443_13487",
    x1: 20.9326,
    y1: 3.94995,
    x2: 4.12859,
    y2: 4.77488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234764,
    stopColor: "#FF9407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538685,
    stopColor: "#FF7D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799781,
    stopColor: "#FF6A19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3443_13487",
    x1: 20.9326,
    y1: 3.94995,
    x2: 4.16486,
    y2: 5.08454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234764,
    stopColor: "#FF9407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538685,
    stopColor: "#FF7D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799781,
    stopColor: "#FF6A19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFire);
export default __webpack_public_path__ + "static/media/icon-fire.1f02c7775dcae254ee3488be52041c91.svg";
export { ForwardRef as ReactComponent };